import 'sass/app.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import { Amplify } from 'aws-amplify';

import Root from './components/root';
import awsconfig from '../aws-exports';
import * as stores from 'client/shared/stores';
import sessionManager from 'client/shared/session/session-manager';

Amplify.configure(awsconfig);

// Session manager watches the Cognito token, silently refreshes on activity,
// and drives the warning modal rendered by <Root>.
sessionManager.init(stores.userStore);
ReactDOM.render(
	<Provider { ...stores }>
		<Root />
	</Provider>,
	document.getElementById('app')
);
